import type { ApiErrorKind } from "@shared/contracts";

/**
 * Should this failure replace the page with a full-screen error?
 *
 * Only failures that genuinely invalidate the current view qualify. The three
 * excluded kinds all have to stay in place:
 * - `VALIDATION_ERROR` — the user must keep their form to fix it.
 * - `BUSINESS_ERROR` — a rejected login belongs in the form's banner.
 * - `BAD_REQUEST` — the backend returns 400 for an unknown route, and
 *   `ErrorRoutes` has no 400 branch, so it would fall through to the **500
 *   page**. A toast is the honest signal until 400 stops being overloaded.
 */
export function isNavigableError(kind: ApiErrorKind | undefined): boolean {
  if (!kind) return true;
  return !(
    kind === "VALIDATION_ERROR" ||
    kind === "BUSINESS_ERROR" ||
    kind === "BAD_REQUEST"
  );
}
